var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1898_9410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 15L21.8521 16.913C20.9501 18.417 20.5001 19.169 20.5001 20C20.5001 20.83 20.9501 21.583 21.8531 23.087L22.5731 24.285C22.7631 24.605 22.8601 24.765 23.0011 24.765C23.1421 24.765 23.2381 24.605 23.4301 24.285L24.1491 23.087C25.0501 21.583 25.5001 20.831 25.5001 20C25.5001 19.17 25.0501 18.417 24.1471 16.913L23.0001 15ZM23.0001 15V13M31.1601 23.598L28.9301 23.561C27.1761 23.531 26.3001 23.516 25.5801 23.931C24.8601 24.347 24.4341 25.114 23.5831 26.648L22.9051 27.869C22.7241 28.195 22.6341 28.358 22.7051 28.48C22.7751 28.603 22.9611 28.606 23.3331 28.612L24.7311 28.636C26.4841 28.666 27.3611 28.68 28.0811 28.264C28.8011 27.849 29.2261 27.082 30.0781 25.549L31.1601 23.598ZM31.1601 23.598L32.8921 22.598",
    stroke: "#6D5FF2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8401 23.5981L17.0701 23.5611C18.8241 23.5311 19.7001 23.5161 20.4201 23.9311C21.1401 24.3471 21.5661 25.1141 22.4171 26.6481L23.0951 27.8691C23.2761 28.1951 23.3661 28.3581 23.2951 28.4801C23.2251 28.6031 23.0391 28.6061 22.6671 28.6121L21.2691 28.6361C19.5161 28.6661 18.6391 28.6801 17.9191 28.2641C17.1991 27.8491 16.7741 27.0821 15.9231 25.5491L14.8401 23.5981ZM14.8401 23.5981L13.1081 22.5981M23.0001 26.0001V33.5001",
    stroke: "#6D5FF2",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1898_9410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbs);
export default __webpack_public_path__ + "static/media/Carbs.74d2b6b01328f0ad0286d89856f8bef4.svg";
export { ForwardRef as ReactComponent };